import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import { getOtherIncomeInput, OtherIncomeModel } from './model';

export function useGetOtherIncomeDetail(
  input?: getOtherIncomeInput,
  options?: UseQueryOptions<ApiResult<OtherIncomeModel>, ApiError>,
): UseQueryResult<ApiResult<OtherIncomeModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getOtherIncomes', input?.id],
      () =>
        QueryFetchFunction({
          url: `other-incomes/${input?.id}`,
        }),
      options,
    ),
    OtherIncomeModel,
  );
}

export function getOtherIncomeKey(input?: getOtherIncomeInput) {
  return ['getOtherIncomes', input?.id];
}
